























































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
const { VUE_APP_API } = process.env;
const API = {
  query: `${VUE_APP_API}/qy/withdraw/detail`,
  ckeckYes: `${VUE_APP_API}/qy/withdraw/check-yes`,
  checkNo: `${VUE_APP_API}/qy/withdraw/check-no`,
};

@Component
export default class FinanceDetail extends Vue {
  isLoading: boolean = false;
  financeMsg: any = [];
  detailData: any = [];
  money: any = '';
  total_amount: any = '';
  total_post_amount: any = '';
  service_money: any = '';
  check_status: any = '';
  orderList: any = [];
  activityList: any = [];
  logList: any = [];
  isShowModel: boolean = false;
  reason: any = '';
  isPayFail: boolean = false;

  query() {
    this.isLoading = true;
    const queryId = this.$route.query.id;
    return this.$axios
      .get(API.query, { params: { withdraw_no: queryId } })
      .then((res: AxiosResponse) => {
        const remote = res.data;
        if (remote.error) {
          this.$message.error(remote.message);
          return;
        }
        this.detailData = [remote.data];
        this.money = remote.data.money;
        this.total_amount = remote.data.total_amount;
        this.total_post_amount = remote.data.total_post_amount;
        this.service_money = remote.data.service_money;
        this.check_status = remote.data.check_status;
        this.orderList = remote.data.order_list;
        this.activityList = remote.data.activity_list;
        this.logList = remote.data.log_list;
        const newData = new Date().getTime();
        const activeTime = new Date(remote.data.pay_time).getTime();
        if (newData - activeTime <= 604800000) {
          this.isPayFail = true;
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  checkNo() {
    if (!this.reason) {
      this.$message.error('请填写不通过原因');
      return;
    }
    this.$axios
      .post(API.checkNo, {
        withdraw_no: this.$route.query.id,
        reason: this.reason,
      })
      .then((res: AxiosResponse) => {
        const remote = res.data;
        if (remote.error) {
          this.$message.error(remote.message);
          return;
        }
        this.$message.success('提交成功');
        this.query();
      })
      .finally(() => {
        this.isShowModel = false;
      });
  }

  checkYes() {
    this.$axios
      .post(API.ckeckYes, { withdraw_no: this.$route.query.id })
      .then((res: AxiosResponse) => {
        const remote = res.data;
        if (remote.error) {
          this.$message.error(remote.message);
          return;
        }
        this.$message.success('审核通过');
        this.query();
      });
  }

  async created() {
    await this.query();
  }
}
